import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref } from "vue";
import InlineSvg from "vue-inline-svg";
import FooterButton from "@/components/shared/button/FooterButton.vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import NewRouteStatusChip from "@/components/shared/chip/NewRouteStatusChip.vue";
import dayjs from "dayjs";
import { useUserStore } from "@/stores/userStore";
import { INewRouteApplicationDetail } from "@/domain/entities/bbs";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";


const __default__ = {
  name: "NewRouteApplicationDetail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  applicationDetail: {
    type: Object as PropType<INewRouteApplicationDetail>,
    required: true,
  },
},
  emits: ["onClickEditBtn", "onClickDeleteBtn", "onClickReceiveResultBtn", "onClickMap"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

const scrollContainer = ref<HTMLElement>();

const userInfo = computed(() => userStore.userInfo);
const isMyPost = computed(
  () =>
    props.applicationDetail.memberUid !== undefined &&
    userInfo.value?.uid === props.applicationDetail.memberUid
);
const isRecipient = computed(() =>
  props.applicationDetail.receivers.some(
    (receiver) => receiver.userUid === userInfo.value?.uid
  )
);

const receiversWithoutSelf = computed(() =>
  props.applicationDetail.receivers.filter(
    (receiver) => receiver.userUid !== userInfo.value?.uid
  )
);

const shouldShowEditAndDeleteButtons = computed(
  () =>
    isMyPost.value &&
    !props.applicationDetail.replies?.length &&
    !receiversWithoutSelf.value.length
);

const usePeriodDisplayText = computed(() => {
  const useBeginDate = props.applicationDetail?.useBeginDtm
    ? dayjs(props.applicationDetail?.useBeginDtm).format("YYYY-MM-DD")
    : "";
  const useEndDate = props.applicationDetail?.useEndDtm
    ? dayjs(props.applicationDetail?.useEndDtm).format("YYYY-MM-DD")
    : "";
  return `${useBeginDate}~${useEndDate}`;
});

const emitOnClickEditBtn = () => {
  emit("onClickEditBtn");
};

const emitOnClickDeleteBtn = () => {
  emit("onClickDeleteBtn");
};

const emitOnClickReceiveResultBtn = () => {
  emit("onClickReceiveResultBtn");
};

const emitOnClickMap = () => {
  emit("onClickMap");
};

const goToNewRouteApplicationList = () => {
  route.meta.willGoBack = true;
  router.back();
};

const __returned__ = { props, emit, route, router, userStore, scrollContainer, userInfo, isMyPost, isRecipient, receiversWithoutSelf, shouldShowEditAndDeleteButtons, usePeriodDisplayText, emitOnClickEditBtn, emitOnClickDeleteBtn, emitOnClickReceiveResultBtn, emitOnClickMap, goToNewRouteApplicationList, get InlineSvg() { return InlineSvg }, FooterButton, NewRouteStatusChip, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})